import { createAsyncThunk } from '@reduxjs/toolkit';
import {
  fetchMaterialDetail,
  type MaterialDetailInput,
} from '../api/fetch-material-detail.api';
import type { ApiError } from '@/utils/types';

export const getMaterialDetail = createAsyncThunk(
  'MatchMaker/getMaterialDetail',
  async (params: MaterialDetailInput, thunkAPI) => {
    try {
      // Call API to get material detail
      return await fetchMaterialDetail(params);
    } catch (e: unknown) {
      // Return error if API call fails
      return thunkAPI.rejectWithValue(
        (e as ApiError).message || 'Failed to fetch material detail'
      );
    }
  }
);
